/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_4_TitleInputs */

const en_mk_sec_4_title = /** @type {(inputs: Mk_Sec_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full audit log`)
};

const id_mk_sec_4_title = /** @type {(inputs: Mk_Sec_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit log lengkap`)
};

/**
* | output |
* | --- |
* | "Full audit log" |
*
* @param {Mk_Sec_4_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_4_title = /** @type {((inputs?: Mk_Sec_4_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_4_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_4_title(inputs)
	return en_mk_sec_4_title(inputs)
});